import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/bitrise/src/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/bitrise/src/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import router from "./router";
import store from "./store";
import NProgress from 'nprogress'; // progress bar

import 'nprogress/nprogress.css'; // progress bar style

import { getToken } from '@/utils/auth'; // get token from cookie

import getPageTitle from '@/utils/get-page-title';
NProgress.configure({
  showSpinner: false
}); // NProgress Configuration

var whiteList = ['/login', '/auth-redirect']; // no redirect whitelist

router.beforeEach(
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(to, from, next) {
    var hasToken, hasRoles, _ref2, roles, accessRoutes;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // start progress bar
            NProgress.start(); // set page title

            document.title = getPageTitle(to.meta.title); // determine whether the user has logged in

            hasToken = getToken();

            if (!hasToken) {
              _context.next = 34;
              break;
            }

            if (!(to.path === '/login')) {
              _context.next = 9;
              break;
            }

            // if is logged in, redirect to the home page
            next({
              path: '/'
            });
            NProgress.done();
            _context.next = 32;
            break;

          case 9:
            // determine whether the user has obtained his permission roles through getInfo
            hasRoles = store.getters.roles && store.getters.roles.length > 0;

            if (!hasRoles) {
              _context.next = 14;
              break;
            }

            next();
            _context.next = 32;
            break;

          case 14:
            _context.prev = 14;
            _context.next = 17;
            return store.dispatch('user/getInfo');

          case 17:
            _ref2 = _context.sent;
            roles = _ref2.roles;
            _context.next = 21;
            return store.dispatch('permission/generateRoutes', roles);

          case 21:
            accessRoutes = _context.sent;
            // dynamically add accessible routes
            router.addRoutes(accessRoutes); // hack method to ensure that addRoutes is complete
            // set the replace: true, so the navigation will not leave a history record

            next(_objectSpread({}, to, {
              replace: true
            }));
            _context.next = 32;
            break;

          case 26:
            _context.prev = 26;
            _context.t0 = _context["catch"](14);
            _context.next = 30;
            return store.dispatch('user/resetToken');

          case 30:
            next("/login?redirect=".concat(to.path));
            NProgress.done();

          case 32:
            _context.next = 35;
            break;

          case 34:
            /* has no token*/
            if (whiteList.indexOf(to.path) !== -1) {
              // in the free login whitelist, go directly
              next();
            } else {
              // other pages that do not have permission to access are redirected to the login page.
              next("/login?redirect=".concat(to.path));
              NProgress.done();
            }

          case 35:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[14, 26]]);
  }));

  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
router.afterEach(function () {
  // finish progress bar
  NProgress.done();
});